// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResultsMessage_wrapper__ltg0d","title":"SearchResultsMessage_title__jP_kF"};